import { BaseOperationHandler } from "@/Common/Stores/Handlers/Local/BaseOperationHandler";

class ReportingHandler extends BaseOperationHandler {
    constructor() {
        super();
        // this.RegisterOperation(LocalOperations.Labs.OnNameChange, this.OnNameTextChange);
    }
}

export { ReportingHandler };
